// REVEAL ШАГА 5 — расписание кадров и память «один раз за сессию». B7-4 `3e619875cbb881b0b3fdd537ef9a459c`.
//
// ИСТОЧНИК ТАЙМИНГОВ — байт борда `Life Map - s5 Red Line v7.html` (sha256 `6a1fbb7a…`), `reveal()`
// `:645–682`, плюс `s680.d2` (каденция точек). Хэндофф `s5-red-line-handoff.md` `:140–163` и
// `s5-interaction-spec.md:14` — справка, не источник (`s946.d4`, `s952.d2` п. 1).
//
// ⭐ ПАМЯТЬ — ТОКЕН `'s5'` В `revealsPlayed`, А НЕ КЛЮЧ `lm.s5.seen` (`s952.d2` п. 2). Ключ — байт
// борда (`:698`, `:746`), в код не идёт: у визарда один конверт, и «один раз за сессию» в нём уже
// живёт (`s864.d1`, `s903.d2`; соседи — `s3/wall`, `s3/demo`). Форма конверта не меняется,
// `SCHEMA_VERSION` не поднимается. `start over` сбрасывает (`s866.d1`), перезагрузка — нет.
//
// ⛔ ПОДПИСЕЙ КАДРОВ НЕТ (`t.rv.0` / `t.rv.1` сняты `s454.d5`), строк ожидания System 2 НЕТ
// (`s453.d2`): reveal печатает ровно то, что печатает кадр покоя, только позже.

/** Токен памяти reveal в `revealsPlayed` (`s952.d2` п. 2). */
export const REVEAL_TOKEN = 's5';

/** Сыгран ли reveal шага 5 в этой сессии. */
export function revealPlayed(revealsPlayed) {
  return Array.isArray(revealsPlayed) && revealsPlayed.includes(REVEAL_TOKEN);
}

/**
 * Записать reveal в сыгранные. Прежний массив, если токен уже там, — держатель стейта сравнивает по
 * ссылке и лишней записи в хранилище не делает (как `rememberDemo`).
 */
export function rememberReveal(revealsPlayed) {
  const played = Array.isArray(revealsPlayed) ? revealsPlayed : [];
  return played.includes(REVEAL_TOKEN) ? played : [...played, REVEAL_TOKEN];
}

/**
 * Кадры, мс от монтирования экрана. Каждое число — байт v7:
 *   · `FADE`   `:651` — пять не-несущих гаснут до нуля, источники оседают на `.38`;
 *   · `WIPE`   `:653` — красная и гало проявляются, маска штриха едет слева направо;
 *   · `PULSE`  `:659` — гало начинает дышать;
 *   · `DOTS`   `:674` — серые точки этапов-не-носителей, и с него же первая номерная точка;
 *   · `COPY`   `:679` — строка чтения и карточка имени (`.iq.on`, `.nameb.on`);
 *   · `EV`     `:680` — карточки доказательств (`.ev.on`, каскад `transition-delay` `:603`);
 *   · `END`    `:681` — фаза покоя, `skip` уходит;
 *   · `SAFETY` `:682` — страховочный таймер: не в покое к этому моменту — в покой.
 */
export const RV = Object.freeze({
  FADE: 420, WIPE: 1120, PULSE: 2140, DOTS: 2180, COPY: 2600, EV: 2700, END: 2900, SAFETY: 3300,
});

/** Конец ряда номерных точек при сжатом шаге (`s680.d2`, v7 `:673`). */
export const DOTS_END = 2540;

/** Шаг каденции точек, мс (`s680.d2`; спека — 140). */
export const DOT_STEP = 140;

/** Ход маски штриха (v7 `:657`): `transform 1s cubic-bezier(.65,0,.35,1)`. */
export const WIPE_TRANSITION = 'transform 1s cubic-bezier(.65,0,.35,1)';

/** Ход непрозрачности узлов чарта во время reveal (v7 `:647`) и при `skip` (`settle()` `:685`). */
export const PT_TRANSITION_REVEAL = 'opacity .5s ease-out';
export const PT_TRANSITION_SKIP = 'opacity .3s';

/** Каскад карточек доказательств, с (v7 `:603` — `transition-delay:${j*.14}s`). */
export const EV_STAGGER_S = 0.14;

/**
 * Моменты появления номерных точек — по одной на носителя (`s680.d2`, v7 `:672–678`).
 *
 * Шаг 140 мс держится, пока весь ряд влезает до кадра копи; при большем числе носителей шаг
 * сжимается так, чтобы ряд кончился к 2540. При трёх — дословно 2180 · 2320 · 2460.
 *
 * @param {number} m число носителей (полный список, не капнутый — точек капа нет, `s679.d1`)
 * @returns {number[]}
 */
export function dotFrames(m) {
  const step = m > 1 ? Math.min(DOT_STEP, (DOTS_END - RV.DOTS) / (m - 1)) : DOT_STEP;
  return Array.from({ length: m }, (_, j) => Math.round(RV.DOTS + step * j));
}

/** Все моменты, в которые экран меняет кадр (без страховки), по возрастанию, без повторов. */
export function revealSchedule(m) {
  const all = [RV.FADE, RV.WIPE, RV.PULSE, RV.DOTS, ...dotFrames(m), RV.COPY, RV.EV, RV.END];
  return [...new Set(all)].sort((a, b) => a - b);
}

/** Хочет ли человек меньше движения. Без `matchMedia` (jsdom, SSR) — нет. */
export function prefersReducedMotion() {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
